export default [
    "top_marks",
    "lowest_marks",
    "most_recent",
]